<template>
  <div id="Mzfestival" class="ACD18 text-NotoSansRegular mx-auto max-w-6xl">
    <div class="banner">
      <div class="">
        <img src="~@/assets/images/EDM-PACK/1200-800-main.png" class="object-contain max-w-full w-full">
      </div>
    </div>
    <nav class="nav mb-10">
      <ul class="flex justify-center items-center text-md md:text-xl menu-blue font-bold">
        <li class="flex-1 md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toMagIntro">雜誌介紹</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1 md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer whitespace-no-wrap text-center" @click="toToolIntro">學習工具介紹</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1 md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toPlan">活動方案</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1 md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="toBuy">立即選購</a>
        </li>
        <li class="text-sm">|</li>
        <li class="flex-1 md:flex-initial">
          <a class="px-1 md:px-5 py-4 block cursor-pointer text-center" @click="tosNote">注意事項</a>
        </li>
      </ul>
    </nav>
    <main class="pb-12 px-2">
      <!-- LiveABC互動英日語雜誌介紹 -->
      <div class="flex items-center justify-center mb-5 flex-wrap" id="toMagIntro">
        <img src="~@/assets/images/EDM-PACK/dog-01-cycle.png" class="object-contain mx-4">
        <div class="mx-4 pb-3 font-bold main-title relative">
          <h6 class="text-xl lg:text-3xl blue-text tracking-wider">LiveABC互動英日語雜誌介紹</h6>
        </div>
        <div class="mx-4 text-md lg:text-xl blue-text yellow-bg py-2 px-3 lg:px-4 font-bold rounded-lg w-full md:w-auto mt-4 md:mt-0">
          <p class="mb-0">全新『雙效學習組合』：</p>
          <p>每月附電腦互動學習軟體＋一片朗讀CD</p>
        </div>
      </div>
      <div class="mb-6">
        <div class="flex flex-wrap">
          <div class="mag-item w-full md:w-1/2 flex p-2" v-for="(item, index) in magzine" :key="index">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="block">
              <div class="mag-item-inner flex rounded-lg p-2 hover:shadow-md">
                <div class="w-2/5 p-4">
                  <img :src="item.img_url" class="object-contain book">
                </div>
                <div class="w-3/5 p-2 flex flex-col justify-center leading-relaxed">
                  <img :src="item.logo_url" class="object-contain mag-item-logo">
                  <h6 class="text-lg md:text-xl font-bold tracking-wider">{{ item.slogan }}</h6>
                  <p>適用程度：{{ item.leval }}</p>
                  <p>適用族群：{{ item.people }}</p>
                  <p>學習目標：{{ item.target }}</p>
                  <div class="mt-2">
                    <a class="blue-bg text-white w-auto inline-block px-4 py-1 pb-2 rounded-full text-sm">立即訂購<font-awesome-icon icon="play" class="font-awesome text-white ml-2 mb-0 text-xs" /></a>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="mag-item w-full md:w-1/2 flex p-2">
            <div class="dog-item-inner rounded-lg p-4 w-full blue-bg text-white leading-relaxed tracking-wider">
              <h6 class="text-lg font-bold">#互動英語雜誌</h6>
              <p><font-awesome-icon icon="check-circle" class="check-circle mr-1" />最道地的英語教材，深度教學內容，題材豐富多元！</p>
              <p><font-awesome-icon icon="check-circle" class="check-circle mr-1" />網羅所有時事新聞、單字、文法、題型！</p>
              <p class=" mb-5"><font-awesome-icon icon="check-circle" class="check-circle mr-1" />內容符合108課綱，有效加強英語閱讀素養！</p>

              <h6 class="text-lg font-bold">#互動日本語雜誌</h6>
              <p><font-awesome-icon icon="check-circle" class="check-circle mr-1" />國內第一本影音互動日語學習雜誌！</p>
              <p><font-awesome-icon icon="check-circle" class="check-circle mr-1" />每月附日檢JLPT模擬考題，訓練應考能力！</p>
              <p><font-awesome-icon icon="check-circle" class="check-circle mr-1" />每月一個特輯主題，內容學好學滿超透徹！</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 再搭配超強學習工具，學習語言輕鬆又有趣！ -->
      <div class="flex items-center justify-center mb-5" id="toToolIntro">
        <img src="~@/assets/images/EDM-PACK/dog-02-cycle.png" class="object-contain mx-4">
        <div class="mx-4 pb-3 font-bold main-title relative">
          <h6 class="text-xl lg:text-3xl blue-text tracking-wider">再搭配超強學習工具，學習語言輕鬆又有趣！</h6>
        </div>
      </div>
      <div class="flex flex-wrap mb-6">
        <div class="tools-item w-full md:w-1/3 flex p-2" v-for="(item, index) in tools" :key="index">
          <div class="tools-item-inner rounded-lg w-full">
            <div class="title text-center text-white py-2 md:py-3 blue-bg">
              <h5 class="text-xl font-bold tracking-wider">{{ item.title }}</h5>
            </div>
            <div class="p-3">
              <img :src="item.img_url" class="object-contain mx-auto mb-2">
              <p class="blue-text text-lg px-1">{{ item.word }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 活動方案 -->
      <div class="flex items-center justify-center mb-5" id="toPlan">
        <img src="~@/assets/images/EDM-PACK/dog-03-cycle.png" class="object-contain mx-4">
        <div class="mx-4 pb-3 font-bold main-title relative">
          <h6 class="text-xl lg:text-3xl blue-text tracking-wider">活動方案</h6>
        </div>
      </div>
      <!-- 活動方案/好康1 -->
      <div class="free-oupon text-center px-2 mb-4">
        <h6 class="text-xl md:text-2xl lg:text-3xl font-bold">好康1.全新方案 - 雙效學習組合，現在訂享限時優惠價！</h6>
        <p class="text-lg">每月附：雜誌＋軟體下載序號(含電腦互動學習軟體、課文朗讀及講解MP3、點讀音檔)＋ 課文朗讀CD(每月送你學習軟體 + 一片課文朗讀CD 哦！)</p>
      </div>
      <div class="flex flex-wrap mb-4">
        <div class="w-full md:w-1/3 p-4" v-for="(item, index) in plan" :key="index">
          <a class="block">
            <img :src="item.img_url" class="object-contain w-full h-auto">
          </a>
        </div>
      </div>
      <!-- 活動方案/好康2 -->
      <div class="free-oupon text-center px-2 mb-4">
        <h6 class="text-xl md:text-2xl lg:text-3xl font-bold">好康2 活動期間凡訂閱雜誌，<span class="text-2xl md:text-3xl lg:text-4xl blue-text font-black">再抽iPhone 12 Pro Max！</span></h6>
      </div>
      <div class="flex flex-wrap mb-4">
        <div class="w-full md:w-1/2 p-4 flex" v-for="(item, index) in prize" :key="index">
          <div class="w-1/2">
            <img :src="item.img_url" class="object-contain w-full h-auto">
          </div>
          <div class="w-1/2 flex flex-col justify-center">
            <span class="text-center text-lg lg:text-2xl blue-bg p-4 rounded-full w-16 lg:w-20 h-16 lg:h-20 whitespace-no-wrap leading-loose yellow-text">{{ item.ranking }}</span>
            <h6 class="text-lg md:text-xl font-bold">{{ item.name }}</h6>
            <p class="text-lg font-bold">{{ item.price }}</p>
          </div>
        </div>
      </div>
      <!-- 活動方案/好康3 -->
      <div class="free-oupon text-center px-2 mb-4">
        <h6 class="text-xl md:text-2xl lg:text-3xl font-bold">好康3.精選口袋書任你選，最高9本帶著走！</h6>
      </div>
      <div class="w-full p-4 mb-6">
        <img src="~@/assets/images/EDM-PACK/gift-book.png" class="object-contain mx-4">
      </div>
      <!-- 點我即刻搶訂去 btn -->
      <div class="cartBtn flex justify-center mb-12" id="toBuy">
        <router-link :to="{ name: 'sale', params: { category: 'recent' }, query: { tag: 83 } }" class="cursor-pointer inline-block yellow-bg blue-text px-8 md:px-12 lg:px-20 py-4 w-auto text-2xl md:text-3xl rounded-lg font-black">點我即刻搶訂去 GO！</router-link>
      </div>

      <!-- 注意事項 -->
      <div class="flex items-center justify-center mb-6" id="tosNote">
        <img src="~@/assets/images/EDM-PACK/dog-01-cycle.png" class="object-contain mx-4">
        <div class="mx-4 pb-3 font-bold main-title relative">
          <h6 class="text-xl lg:text-3xl blue-text tracking-wider">注意事項</h6>
        </div>
      </div>
      <p class="font-bold leading-loose">1. 抽獎辦法：即日起至2021/9/30止，訂閱LiveABC互動英日語雜誌任一刊雜誌，即可參加抽獎。2. 抽獎公佈日期：2021/10/15公佈於LiveABC官方網站（https://store.liveabc.com/）。3. 中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。4. 中華民國稅法規定，凡贈與獎項金額超過新台幣20,000元，將依法課徵10%所得稅。5. 由於中獎獎品之價值會受市場價格波動之影響，因此以中獎通知單內所標明之贈品價值為準。6. 本活動之抽獎贈品不得轉換、轉讓或折換現金。7. 如提供獎項因故無法取得，本公司保留替換其他等 獎項及變更、修改本活動之權利。</p>
    </main>
  </div>
</template>

<script>
import jump from 'jump.js'
export default {
  name: 'Mzfestival',
  metaInfo () {
    return {
      title: 'LiveABC英日語雜誌歡慶升級改版',
      titleTemplate: null
    }
  },
  data () {
    return {
      magzine: [
        { id: 6537, img_url: require('@/assets/images/EDM-PACK/MG-COVER/ABC.jpeg'), logo_url: require('@/assets/images/EDM-PACK/LOGO/ABC-LOGO.svg'), slogan: '打好英語基礎的最佳選擇！', leval: '進階英語學習', people: '國中小學生～成人，英語初學者', target: '奠定英語能力，加強聽說寫作能力，相當於大學非英語主修系所畢業。' },
        { id: 6525, img_url: require('@/assets/images/EDM-PACK/MG-COVER/LIVE.jpeg'), logo_url: require('@/assets/images/EDM-PACK/LOGO/LIVE-LOGO.svg'), slogan: '日常生活實用英語輕鬆學！', leval: '全民英檢中級', people: '國高中生～成人、一般生活英語會話', target: '具備一般生活會話溝通、基本寫作、文章閱讀能力，相當於高中畢業程度。' },
        { id: 6529, img_url: require('@/assets/images/EDM-PACK/MG-COVER/ALL.jpeg'), logo_url: require('@/assets/images/EDM-PACK/LOGO/ALL-LOGO.svg'), slogan: '閱讀寫作訓練豐富又多元！', leval: '進階英語學習', people: '具基礎能力，想要英語再升級的高中生～成人', target: '英語能力日趨成熟，加強聽說寫作能力，相當於大學非英語主修系所畢業。' },
        { id: 6533, img_url: require('@/assets/images/EDM-PACK/MG-COVER/CNN.jpeg'), logo_url: require('@/assets/images/EDM-PACK/LOGO/CNN-LOGO.svg'), slogan: '官方授權的專業新聞素材！', leval: '專業新聞英語學習', people: '準備出國留學或商務人士', target: '熟悉美國文化與美語口音和常用俚語，熟稔國際新聞大事，用英語社交聊天沒問題。' },
        { id: 6541, img_url: require('@/assets/images/EDM-PACK/MG-COVER/JAPAN.jpeg'), logo_url: require('@/assets/images/EDM-PACK/LOGO/JP-LOGO.svg'), slogan: '日籍老師主編內容實用到位！', leval: '基礎～初中級', people: '具備一般日語閱讀能力，適用JLPT測驗N5-N3檢定', target: '具備日常生活日文閱讀能力，能聽懂日常會話，基礎日語溝通沒問題。' }
      ],
      tools: [
        { title: 'QR code', img_url: require('@/assets/images/EDM-PACK/QRCODE.png'), word: '掃描上方QR code即可進入課程選單，有課文音檔、單字例句音檔和講解影片。' },
        { title: 'LiveABC智慧點讀筆', img_url: require('@/assets/images/EDM-PACK/tool-pen.png'), word: '雜誌皆為點讀版，讓你隨點隨唸、走到哪、讀到哪，不受任何時間地點限制。' },
        { title: '電腦互動學習軟體&課文朗讀CD', img_url: require('@/assets/images/EDM-PACK/CD-ROM.png'), word: '下載安裝電腦互動學習軟體或是使用課文朗讀CD，學習方便又有效率！' }
      ],
      plan: [
        { img_url: require('@/assets/images/EDM-PACK/price-1790.png') },
        { img_url: require('@/assets/images/EDM-PACK/price-3290.png') },
        { img_url: require('@/assets/images/EDM-PACK/price-4550.png') }
      ],
      prize: [
        { img_url: require('@/assets/images/EDM-PACK/iphone-12-pro-blue-hero.png'), ranking: '首獎', name: 'iPhone 12 Pro Max (乙名)', price: '價值37,900元' },
        { img_url: require('@/assets/images/EDM-PACK/livepen-tilt-ransparent.png'), ranking: '貳獎', name: 'LiveABC智慧點讀筆 (五名)', price: '價值2,490元' }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toMagIntro () {
      jump('#toMagIntro', {
        duration: 500,
        offset: 0
      })
    },
    toToolIntro () {
      jump('#toToolIntro', {
        duration: 800,
        offset: 0
      })
    },
    toPlan () {
      jump('#toPlan', {
        duration: 900,
        offset: 0
      })
    },
    toBuy () {
      jump('#toBuy', {
        duration: 1000,
        offset: 0
      })
    },
    tosNote () {
      jump('#tosNote', {
        duration: 1000,
        offset: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  $main-dark: #F8D700;
  $main-blue: #002985;
  .menu-blue {
    color: #0C2D3D;
  }
  .blue-text {
    color: $main-blue;
  }
  .yellow-text {
    color: $main-dark;
  }
  .blue-bg {
    background-color: $main-blue;
  }
  .yellow-bg {
    background-color: $main-dark;
  }
  .check-circle {
    color: #4BD37B;
  }
  #Mzfestival {
    .nav {
      border-bottom: 2px solid $main-blue;
      border-color: $main-blue;
    }
    .main-title {
      &:after {
        content: '';
        position: absolute;
        bottom: -.2em;
        left: 0%;
        width: 100%;
        height: 8px;
        background: #A3A3A3;
        @media (min-width: 768px) {
          content: '';
          position: absolute;
          bottom: -.5em;
          left: -1%;
          width: 102%;
          height: 10px;
          background: #A3A3A3;
        }
      }
    }
    .mag-item {
      .mag-item-inner {
        background-color: #F2F2F2;
        .book {
          filter: drop-shadow(8px 8px 1px rgba(0,0,0,.4));
        }
      }
      .mag-item-logo {
        max-width: 180px;
      }
      .dog-item-inner {
        @media (min-width: 1024px) {
        background-color: $main-blue;
        background-image: url('~@/assets/images/EDM-PACK/dog-01.png');
        background-repeat: no-repeat;
        background-size: 8em;
        background-position: bottom 0 right 2%;
        }
        @media (min-width: 1200px) {
        background-color: $main-blue;
        background-image: url('~@/assets/images/EDM-PACK/dog-01.png');
        background-repeat: no-repeat;
        background-size: 9em;
        background-position: bottom 0 right 5%;
        }
      }
    }

    .tools-item {
      .tools-item-inner {
        .title {
          background: $main-blue;
        }
        border: 2px solid $main-blue;
      }
    }
    .cartBtn {
      filter: drop-shadow(8px 8px 1px rgba(0,0,0,.4));
    }
  }
</style>
